import type { ExtractionPreviewData } from "@/types";

export interface PipelinePreviewCacheEntry {
  preview: ExtractionPreviewData;
  fetchedAt: number;
}

const previewCache = new Map<string, PipelinePreviewCacheEntry>();

export function getCachedPipelinePreview(fileId: string): ExtractionPreviewData | null {
  return previewCache.get(fileId)?.preview ?? null;
}

export function setCachedPipelinePreview(fileId: string, preview: ExtractionPreviewData): void {
  previewCache.set(fileId, { preview, fetchedAt: Date.now() });
}

export function invalidatePipelinePreviewCache(fileId?: string): void {
  if (fileId) {
    previewCache.delete(fileId);
    return;
  }
  previewCache.clear();
}

export async function runWithConcurrencyLimit<T>(
  items: string[],
  limit: number,
  worker: (fileId: string) => Promise<T>
): Promise<void> {
  if (items.length === 0) return;
  const queue = [...items];
  const concurrency = Math.max(1, Math.min(limit, queue.length));

  await Promise.all(
    Array.from({ length: concurrency }, async () => {
      while (queue.length > 0) {
        const fileId = queue.shift();
        if (!fileId) return;
        await worker(fileId);
      }
    })
  );
}
